import * as ng from 'angular';
import { BaseUrlService } from '../../../services/base-url.service';
import { rabbitMQ } from '../../../third/rabbitMQ';
import { googleAPI } from '../../../third/googleAPI';
import { StorageService } from '../../../services/storage.service';
import { UserService } from '../../../services/user.service';
import { ArchiSmallServices } from '../../../services/archismall.service';
import { ValidationService } from '../../../services/validation.service';

export class SubscriptionRenewalController implements ng.IController {
    static $inject: string[] = [
        '$rootScope',
        '$scope',
        '$state',
        'ArchiSmallServices',
        'store',
        '$uibModal',
        'BaseUrlService',
        'configuration',
        '$http',
        '$timeout',
        '$sce',
        '$parse',
        '$filter',
        'user',
        'ValidationService',
        'StorageService',
        'UserService'
    ];

    constructor(
        private $rootScope: any,
        private $scope: any,
        private $state: ng.ui.IStateService,
        private ArchiSmallServices: ArchiSmallServices,
        private store: ng.a0.storage.IStoreService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private baseUrlService: BaseUrlService,
        private configuration: any, // todo specificare il tipo
        private $http: ng.IHttpService,
        private $timeout: ng.ITimeoutService,
        private $sce: ng.ISCEService,
        private $parse: ng.IParseService,
        private $filter: ng.IFilterService,
        private user: any, // todo cambiare
        private ValidationService: ValidationService,
        private StorageService: StorageService,
        private UserService: UserService
    ) {


        $scope.subscriptions = [
            {
                code: 'S1',
                period: '1 Anno',
                total: 400,
                tax: 80
            },
            {
                code: 'S2',
                period: '2 Anno',
                total: 700,
                tax: 90
            },
            {
                code: 'S3',
                period: '3 Anno',
                total: 800,
                tax: 100
            },
            {
                code: 'S4',
                period: '4 Anno',
                total: 890,
                tax: 150
            }
        ];
        $scope.selectedSubscription = (code) => {
            var found = $filter('filter')($scope.subscriptions, { code: code }, true);
            if (found.length) {
                return found[0];
            }
        };
        $scope.currentYear = (new Date()).getFullYear();
        $scope.renewSubscription = () => {
            ArchiSmallServices.renewSubscription()
                .then((response) => {
                    $state.go('usersettings.rinnova-offerta-summary');
                }, (error) => {
                    $rootScope.alert('error', error);
                });
        };

    }
}


export const SubscriptionRenewalComponent: ng.IComponentOptions = {
    template: require('./rinnova-offerta.html'),
    controller: SubscriptionRenewalController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/rinnova-offerta/rinnova-offerta.ts